import React from "react";
import { Container } from "react-bootstrap";

const PrivacyPolicy = () => {
  return (
    <section className="terms-page">
      <Container>
        <div className="terms-title">
          <h1>Privacy Policy</h1>
        </div>

        <div className="privacy-container">

          <p><strong>Effective Date: 14 February 2026</strong></p>

          <p>
            At Plenary Holidays, we recognize that trust is fundamental to every travel relationship. Whether you are an individual traveler or a corporate partner engaging us for a MICE program, we are committed to safeguarding your personal information with professionalism, discretion, and accountability.
          </p>

          <p>
            This Privacy Policy explains how we collect, use, store, and protect information across our website and during the course of our leisure and corporate travel operations.
          </p>

          <hr />

          <h5><strong>1. Information We Collect</strong></h5>

          <p>
            To plan and execute travel arrangements efficiently, we may collect the following categories of information:
          </p>

          <p><strong>Personal Identification</strong></p>
          <p>
            • Name <br />
            • Age and gender <br />
            • Contact details (email address, phone number)
          </p>

          <p><strong>Travel Documentation</strong></p>
          <p>
            • Passport details <br />
            • Visa copies <br />
            • Aadhaar or other government ID (where required for permits in regions such as Sikkim or North East India)
          </p>

          <p><strong>Corporate & MICE Data</strong></p>
          <p>
            • Organization name <br />
            • GST details <br />
            • Delegate or employee lists for conferences, incentive travel, and corporate group movements
          </p>

          <p><strong>Payment Information</strong></p>
          <p>
            • Billing address <br />
            • Transaction references and payment confirmations
          </p>

          <p>
            Note: We do not store complete credit card numbers or banking login credentials on our servers.
          </p>

          <p><strong>Dietary & Health Preferences</strong></p>
          <p>
            • Meal preferences (Vegetarian, Jain, Vegan, etc.) <br />
            • Mobility or accessibility requirements
          </p>

          <p>
            This information is collected strictly for operational and service delivery purposes.
          </p>

          <hr />

          <h5><strong>2. How We Use Your Information</strong></h5>

          <p>
            We use the collected data only for legitimate business purposes, including:
          </p>

          <p>
            • Securing airline tickets, hotel bookings, and transportation <br />
            • Coordinating with Destination Management Companies (DMCs) <br />
            • Processing government permits and travel documentation <br />
            • Issuing GST-compliant invoices and maintaining audit records <br />
            • Managing corporate conferences, exhibitions, and incentive travel programs <br />
            • Providing real-time updates, emergency assistance, and itinerary changes <br />
            • Personalizing itineraries based on client requirements
          </p>

          <p>
            We do not use personal information for unrelated marketing activities without consent.
          </p>

          <hr />

          <h5><strong>3. Data Sharing & Disclosure</strong></h5>

          <p>
            Plenary Holidays does not sell, trade, or rent personal data to third parties.
          </p>

          <p>
            Information is shared only when required for delivering the confirmed service, including:
          </p>

          <p>
            • Airlines and hotels <br />
            • Transport providers and ground operators <br />
            • Insurance partners <br />
            • Government authorities for immigration, permits, or border formalities
          </p>

          <p>
            Disclosure may also occur if required under applicable laws or to protect the safety of our travelers, employees, or partners.
          </p>

          <hr />

          <h5><strong>4. Data Security & Storage</strong></h5>

          <p>
            We maintain structured safeguards to protect personal data against unauthorized access, misuse, or disclosure.
          </p>

          <p><strong>Secure Digital Infrastructure</strong></p>
          <p>
            Our systems operate using encrypted communication protocols to minimize data vulnerability.
          </p>

          <p><strong>Restricted Internal Access</strong></p>
          <p>
            Sensitive traveler and corporate information is accessible only to authorized personnel involved in service execution.
          </p>

          <p><strong>Data Retention</strong></p>
          <p>
            We retain personal and transactional data only as long as necessary to:
          </p>

          <p>
            • Complete travel arrangements <br />
            • Meet accounting and GST compliance requirements <br />
            • Fulfill legal or contractual obligations
          </p>

          <p>
            Once no longer required, data is securely archived or deleted in accordance with internal policy.
          </p>

          <hr />

          <h5><strong>5. Your Rights</strong></h5>

          <p>You may request to:</p>

          <p>
            • Access the personal information we hold about you <br />
            • Correct inaccurate or incomplete data <br />
            • Request deletion of your data after completion of services, subject to statutory retention requirements
          </p>

          <p>
            Requests may be submitted through the contact details provided below.
          </p>

          <hr />

          <h5><strong>6. Third-Party Websites</strong></h5>

          <p>
            Our website may include links to external websites such as airline portals or tourism boards. Plenary Holidays is not responsible for the privacy practices or content of such third-party websites. Users are encouraged to review their respective policies before sharing personal information.
          </p>

          <hr />

          <h5><strong>7. Policy Updates</strong></h5>

          <p>
            As our services evolve and industry standards develop, this Privacy Policy may be updated periodically. Any changes will be reflected on this page with a revised effective date.
          </p>

          <hr />

          <h5><strong>Contact – Data Compliance Desk</strong></h5>

          <p>
            Plenary Holidays <br />
            311, H-4, Vardhman North Ex-Plaza <br />
            Netaji Subhash Place, Pitampura <br />
            New Delhi – 110034 <br />
            <strong>Email:</strong> mail@plenaryholidays.com <br />
            <strong>Phone:</strong> +91-7218701234
          </p>

        </div>
      </Container>
    </section>
  );
};

export default PrivacyPolicy;